// @core/api/endpoints/chat/get_presence.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPresenceRequest,
  GetPresenceResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get presence for users
 * Retrieves the online presence status for multiple users in a single request. Useful for populating member lists with online indicators.
 */
export async function GetPresence(
  data: GetPresenceRequest,
  options?: RequestOptions
): Promise<GetPresenceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/presence/batch`;
  const requestOptions = options;
  return client.post<GetPresenceResponse>(requestPath, data, requestOptions);
}
